/*eslint-disable */
define(function (require) {
    var $ = require('jquery');
    var pageConfig = require('common/page-config');

    var MINUTES_PER_HOUR = 60;
    var HOURS_PER_DAY = 24;

    var durationNames;
    var durationPluralNames;

    function format(duration, allowMixedUnits, otherReferenceData) {
        if (!duration) {
            return;
        }

        durationNames = (otherReferenceData && otherReferenceData.durationNames || pageConfig.durationNames);
        durationPluralNames = (otherReferenceData && otherReferenceData.durationPluralNames || pageConfig.durationPluralNames);

        var days = 0;
        var hours = 0;
        var minutes = 0;

        if (typeof allowMixedUnits === 'undefined') {
            allowMixedUnits = true;
        }

        if (duration.unit === 'MINUTE') {
            if (duration.value >= MINUTES_PER_HOUR) {
                var minutesModulus = duration.value % MINUTES_PER_HOUR;

                if (allowMixedUnits || minutesModulus === 0) {
                    hours = Math.floor(duration.value / MINUTES_PER_HOUR);
                    minutes = minutesModulus;
                } else {
                    minutes = duration.value;
                }

                if (hours >= HOURS_PER_DAY) {
                    var hoursModulus = hours % HOURS_PER_DAY;

                    if (allowMixedUnits || hoursModulus === 0) {
                        days = Math.floor(hours / HOURS_PER_DAY);
                        hours = hoursModulus;
                    }
                }
            } else {
                minutes = duration.value;
            }
        } else if (duration.unit === 'HOUR') {
            if (duration.value >= HOURS_PER_DAY) {
                var hoursModulus = duration.value % HOURS_PER_DAY;

                if (allowMixedUnits || hoursModulus === 0) {
                    days = Math.floor(duration.value / HOURS_PER_DAY);
                    hours = hoursModulus;
                } else {
                    hours = duration.value;
                }
            } else {
                hours = duration.value;
            }
        } else if (duration.unit === 'DAY') {
            days = duration.value;
        }

        return buildDuration(days, hours, minutes);
    }

    function formatRange(minDuration, maxDuration) {
        if (!minDuration || !maxDuration) {
            return "";
        }
        if (minDuration.unit === maxDuration.unit && minDuration.value === maxDuration.value) {
            return format(minDuration);
        } else {
            return format(minDuration) + " - " + format(maxDuration);
        }
    }

    function buildDuration(days, hours, minutes) {
        var formattedDuration = '';

        if (days > 0) {
            formattedDuration += days + ' ';
            formattedDuration += unitSuffix('DAY', days > 1);

            if (hours > 0 || minutes > 0) {
                formattedDuration += ' ';
            }
        }

        if (hours > 0) {
            formattedDuration += hours + ' ';
            formattedDuration += unitSuffix('HOUR', hours > 1);

            if (minutes > 0) {
                formattedDuration += ' ';
            }
        }

        if (minutes > 0) {
            formattedDuration += minutes + ' ';
            formattedDuration += unitSuffix('MINUTE', minutes > 1);
        }

        return formattedDuration;
    }

    function unitSuffix(durationType, plural) {
        var names = plural ? durationPluralNames : durationNames;

        return names[durationType].toLowerCase();
    }

    return {
        format: format,
        formatRange: formatRange
    };
});
